import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Drawer, DrawerHeader, DrawerFooter, DrawerContent, QuickView } from '@sainsburys-tech/bolt'
import CreditOptionsProductContent from './components/CreditOptionsProductContent/CreditOptionsProductContent'
import CreditOptionsMessageContent from './components/CreditOptionsMessageContent/CreditOptionsMessageContent'
import { onCreditOptionsSlidingPanelShut } from './credit-options.tracking'
import { BrandContextConsumer } from '../../providers/BrandConfigContext/BrandConfigContext'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'

class CreditOptions extends PureComponent {
  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      pushEventAndTrack({
        eventInfo: {
          eventName: 'pdp_creditBannerViewed',
          eventAction: 'Credit Banner Viewed'
        }
      })
    }
  }

  toggleCallback = () => {
    if (this.props.show) {
      onCreditOptionsSlidingPanelShut(window)
      this.props.toggleCreditOptions()
    }
  }

  render() {
    const { productId, show, toggleCreditOptions, periodDuration, periodType, isBuyNowPayLater, apr } = this.props
    const footerPortal = 'ac-credit-options__footer'
    const dataTest = 'credit-options-drawer'
    return (
      <Drawer
        position='right'
        show={show}
        onClose={() => this.toggleCallback()}
        padding={false}
        data-test={dataTest}
        ariaLabelledBy='credit-card-link'
      >
        <DrawerHeader>Argos Card</DrawerHeader>
        <DrawerContent>
          <div data-test={dataTest}>
            <QuickView.ProductFetch
              fetch={show}
              partNumbers={[productId]}
              render={({ products, isLoading }) => (
                <CreditOptionsProductContent
                  isLoading={isLoading}
                  product={products[productId]}
                  toggleCreditOptions={toggleCreditOptions}
                  footerPortal={footerPortal}
                  dataTest={dataTest}
                />
              )}
            />
            <BrandContextConsumer>
              <CreditOptionsMessageContent
                periodDuration={periodDuration}
                periodType={periodType}
                isBuyNowPayLater={isBuyNowPayLater}
                apr={apr}
                dataTest={dataTest}
              />
            </BrandContextConsumer>
          </div>
        </DrawerContent>
        <DrawerFooter>
          <div id={footerPortal} />
        </DrawerFooter>
      </Drawer>
    )
  }
}

CreditOptions.propTypes = {
  periodDuration: PropTypes.number,
  periodType: PropTypes.string,
  productId: PropTypes.string,
  show: PropTypes.bool,
  toggleCreditOptions: PropTypes.func,
  isBuyNowPayLater: PropTypes.bool
}

CreditOptions.defaultProps = {
  show: false,
  toggleCreditOptions: () => {}
}
export default CreditOptions
